import React from "react";
import ShopPageDialog from "../components/Dialog";

export default function PrismicPage() {
  return <ShopPageDialog />;
}
